import * as THREE from 'three';
import {ServerModel} from "../../Model/ServerModel";
import {ServerIcon} from "../../Model/ServerIcon";
import {Card} from "../../Shapes/Card";
import {Icon2D} from "../../Shapes/Icon2D";
import {Server} from "../../../../../../../services/model/server.model";
import {ServerPlus} from "../../Shapes/ServerPlus";

export function ManagerServers(
    scene: THREE.Scene,
    zoneX: number,
    zoneZ: number,
    qte: number,
    servers: Array<Server>,
): void {

    const createBlock = (x: number, z: number, name: string, type: string | null, id: string): void => {

        // Création du Server
        const serverModel = new ServerModel(id);
        const server = serverModel.getGroup();

        // Création de l'icône 3D
        const iconModel = new ServerIcon(type);
        const icon = iconModel.getGroup();

        // Icon2D
        const icon2D: THREE.Group = Icon2D(type, id)

        // Card
        const cardModel = new Card(false, name, type || "-");
        const card = cardModel.getGroup();

        // Positionnement
        server.position.set(x, 0.2, z)
        icon.position.set(x + .6, .6, z + .8)
        icon.rotation.x = -Math.PI / 2;
        icon2D.position.set(x, 2, z)
        card.position.set(x, 4, z + 1.5);
        card.rotation.x = -Math.PI / 2;

        // Add in scene
        const group = new THREE.Group();
        group.add(server, icon);
        group.add(icon2D, card);
        scene.add(group);

    };

    // Placement des servers dans la Zone
    const placeBlocks = (n: number) => {
        const rowSize = 4; // 4 blocs par ligne
        let name, type, id;

        for (let i = 0; i < n; i++) {

            let rowIndex = Math.floor(i / rowSize); // Ligne actuelle
            let indexInRow = i % rowSize; // Position dans la ligne
            let totalInRow = Math.min(rowSize, n - rowIndex * rowSize); // Nb de blocs dans la ligne

            let x;
            switch (totalInRow) {
                case 0:
                    x = zoneX;
                    break;
                case 1:
                    x = zoneX;
                    break;
                case 2:
                    x = indexInRow === 0 ? zoneX - 2 : zoneX + 2;
                    break;
                case 3:
                    x = zoneX + (indexInRow - 1) * 4;
                    break;
                case 4:
                    x = zoneX + (indexInRow - 1.5) * 4;
                    break;
                default:
                    x= zoneX;
                    break;
            }

            // Gestion type, name, text
            name = servers[i].name;
            type = servers[i].type;
			id = servers[i].id;

            let z = (zoneZ + 3)+(rowIndex * 4); // Espacement vertical (ajuste la valeur si besoin)

			if (n > 8 && i === 7) {
				ServerPlus(scene, x, z, qte, servers)
				return
			} else {
				createBlock(x, z, name, type, id); // Facteur d'espacement horizontal
			}
        }
    };

    placeBlocks(qte);
}
